// EasySearch custom
document.addEventListener('easysearch_params_saved', event => {
  const routes = {
    'acura'        : 'acura',
    'alfa romeo'   : 'alfa-romeo',
    'aston martin' : 'aston-martin',
    'audi'         : 'audi',
    'bentley'      : 'bentley',
    'bmw'          : 'bmw',
    'buick'        : 'buick',
    'cadillac'     : 'cadillac',
    'can-am'       : 'can-am',
    'chevrolet'    : 'chevrolet',
    'chrysler'     : 'chrysler',
    'dodge'        : 'dodge',
    'ferrari'      : 'ferrari',
    'fiat'         : 'fiat',
    'ford'         : 'ford',
    'genesis'      : 'genesis',
    'gmc'          : 'gmc',
    'havel'        : 'havel',
    'honda'        : 'honda',
    'hummer'       : 'hummer',
    'hyundai'      : 'hyundai',
    'infiniti'     : 'infiniti',
    'jaguar'       : 'jaguar',
    'jeep'         : 'jeep',
    'kia'          : 'kia',
    'lamborghini'  : 'lamborghini',
    'lancia'       : 'lancia',
    'land rover'   : 'land-rover',
    'lexus'        : 'lexus',
    'lincoln'      : 'lincoln',
    'lotus'        : 'lotus',
    'maserati'     : 'maserati',
    'mazda'        : 'mazda',
    'mclaren'      : 'mclaren',
    'mercedes'     : 'mercedes',
    'mercedes-benz': 'mercedes-benz',
    'mg5'          : 'mg',
    'mini'         : 'mini',
    'mitsubishi'   : 'mitsubishi',
    'nio es'       : 'nio',
    'nissan'       : 'nissan',
    'peugeot'      : 'peugeot',
    'pontiac'      : 'pontiac',
    'polaris'      : 'polaris',
    'porsche'      : 'porsche',
    'ram'          : 'ram',
    'renault'      : 'renault',
    'rivian'       : 'rivian',
    'rolls royce'  : 'rolls-royce',
    'saleen'       : 'saleen',
    'scion'        : 'scion',
    'shelby'       : 'shelby',
    'srt'          : 'srt',
    'subaru'       : 'subaru',
    'tank 300'     : 'tank',
    'tesla'        : 'tesla',
    'toyota'       : 'toyota',
    'volvo'        : 'volvo',
    'volkswagen'   : 'vw',
    'xpeng'        : 'xpeng',
    'yamaha'       : 'yamaha',
    'zeekr'        : 'zeekr',
  };

  const holder = event.detail?.holder;
  const url    = event.detail?.url;

  if( easysearch.curIndex && holder && url ) {
    const btn = holder.querySelector('.easysearch-btn-search');
    const value = easysearch.curIndex.split(',')[0]?.toLowerCase();

    if( btn && value && routes[value] ) {
      const newUrl = url.replace('/all/', `/${routes[value]}/`);
      btn.setAttribute('href', newUrl);
      holder.esparams['url'] = newUrl;
    }
  }
});
// EasySearch custom

/* Toggle Class on cart empty -- Start */
(function () {
  const selector = '[data-cart-count]';

  // extract first integer from a string (returns 0 if none)
  function getQuantityFromText(text) {
    const m = (text || '').match(/-?\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  function updateCartEmptyClass() {
    const el = document.querySelector(selector);
    if (!el) return; // don't change body if the element isn't present
    const text = (el.textContent || el.innerText || '').trim();
    const quantity = getQuantityFromText(text);
    document.body.classList.toggle('cart-empty', quantity === 0);
  }

  function observe() {
    // initial check
    updateCartEmptyClass();

    // Observe the element itself for content changes (text updates)
    const el = document.querySelector(selector);
    if (el) {
      const elObserver = new MutationObserver(updateCartEmptyClass);
      elObserver.observe(el, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true
      });
    }

    // Observe the whole document for additions/removals/replacements of the element
    // (covers frameworks that replace nodes)
    const docObserver = new MutationObserver(() => {
      updateCartEmptyClass();
    });
    docObserver.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();


/* Toggle Class on cart empty -- End */